<template>
  <base-page-layout title="E-mail">
    <v-layout class="my-3 btn-nova">
      <v-spacer />
      <mf-button icon="add" label="Nova campanha" @click="redirect()" />
    </v-layout>

    <v-container fluid class="px-0 pt-0" grid-list-lg>
      <v-layout>
        <v-flex v-for="(card, index) in cards" :key="index" xs4>
          <cbm-card :number-text="card.value" :title="card.text" :tooltip="card.helpText" :boolean-loader="card.loading" />
        </v-flex>
      </v-layout>
    </v-container>

    <campaigns-table v-if="isFranchisee" mode="email" logsTag="CAMPAIGNS" :franchisee="true" class="mb-3" :items-filter="filterList[0]">
      <template v-slot:title> Campanhas da rede </template>
    </campaigns-table>
    <campaigns-table mode="email" logsTag="CAMPAIGNS" :items-filter="filterList[1]">
      <template v-slot:title> Minhas campanhas </template>
    </campaigns-table>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CbmCard from '@/components/CbmCard.vue'
import CampaignsTable from '@/modules/campanhas/views/components/index/CampaignsTable.vue'
import {
  QUERY_GET_CREDITS,
  QUERY_GET_SCHEDULED_SENDINGS,
  QUERY_GET_VALID_CONTACTS,
  QUERY_GET_PROVIDER_VALIDATED_CONTACTS,
  QUERY_GET_BLACKLISTED_CONTACTS,
} from '../../graphql'
import { getStatusLabel, localeString } from '@/config/helpers.js'

export default {
  components: {
    BasePageLayout,
    CbmCard,
    CampaignsTable,
  },
  data: () => ({
    credits: null,
    scheduledSendings: null,
    validContacts: null,
    providerValidatedContacts: null,
    blacklist: null,
    filterList: [
      [
        { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      ],
      [
        { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
        { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      ],
    ],
  }),
  computed: {
    cards() {
      return [
        {
          text: 'Créditos',
          value: localeString(this.credits || 0),
          helpText: 'Cada e-mail enviado custa 1 crédito, cada validação de e-mail custa 6 créditos.',
          loading: this.$apollo.queries.credits.loading,
        },
        {
          text: 'Envios agendados',
          value: localeString(this.scheduledSendings || 0),
          isInteger: true,
          helpText: this.isFranchisee ? 'Envios que foram programados por você. Disparos da rede não são contabilizados.' : null,
          loading: this.$apollo.queries.scheduledSendings.loading,
        },
        {
          text: 'E-mails válidos',
          value: localeString(this.validContacts || 0),
          isInteger: true,
          helpText: 'E-mails que respeitam o formato padrão de e-mail.',
          loading: this.$apollo.queries.scheduledSendings.loading,
        },
        {
          text: 'E-mails validados',
          value: localeString(this.providerValidatedContacts || 0),
          isInteger: true,
          helpText: 'E-mails que foram validados pelo provedor.',
          loading: this.$apollo.queries.providerValidatedContacts.loading,
        },
        {
          text: 'Desistências',
          value: localeString(this.blacklist || 0),
          isInteger: true,
          helpText: 'Quantidade de clientes que se descadastraram das campanhas e-mail.',
          loading: this.$apollo.queries.blacklist.loading,
        },
      ]
    },
    isFranchise() {
      // rede
      if (!this.$getLoggedUser().is_franchise) return false
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      // franquia
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
  },
  apollo: {
    credits: {
      query: QUERY_GET_CREDITS,
      update({ balance }) {
        return balance
      },
    },
    scheduledSendings: {
      query: QUERY_GET_SCHEDULED_SENDINGS,
      update({ getNumberOfScheduledSendings }) {
        return getNumberOfScheduledSendings
      },
    },
    validContacts: {
      query: QUERY_GET_VALID_CONTACTS,
      update({ getNumberOfValidContacts }) {
        return getNumberOfValidContacts
      },
    },
    providerValidatedContacts: {
      query: QUERY_GET_PROVIDER_VALIDATED_CONTACTS,
      update({ getNumberOfValidatedContacts }) {
        return getNumberOfValidatedContacts.valid
      },
    },
    blacklist: {
      query: QUERY_GET_BLACKLISTED_CONTACTS,
      update({ getNumberOfBlacklistedContacts }) {
        return getNumberOfBlacklistedContacts
      },
    },
  },
  methods: {
    redirect() {
      this.$router.push('/campanhas/email/nova').catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-nova {
  margin-top: -54px !important;
}
</style>
